import { Lock } from "components/icons/generated";
import Badge from "ds/components/Badge";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";
import Box from "ds/components/Box";

import { InputChange } from "../../types";
import ChangeHistoryCardValueBadge from "./ValueBadge";

type ChangeHistoryCardFieldChangeLineProps = {
  change: InputChange;
};

const ChangeHistoryCardFieldChangeLine = ({ change }: ChangeHistoryCardFieldChangeLineProps) => (
  <Typography tag="div" variant="p-body3" color="secondary">
    <Box gap="small" align="center" wrap>
      <Badge variant="gray" type="weak" text={change.fieldName} />
      {change.secret && <Icon src={Lock} noShrink color="tertiary" />}
      {change.secret ? "checksum changed" : "changed"}
      <ChangeHistoryCardValueBadge
        variant={change.currentValue === "(not set)" ? "red" : "gray"}
        text={change.previousValue}
      />
      to
      <ChangeHistoryCardValueBadge
        variant={change.previousValue === "(not set)" ? "green" : "gray"}
        text={change.currentValue}
      />
    </Box>
  </Typography>
);

export default ChangeHistoryCardFieldChangeLine;
